"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUser(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M15.92145,14.83936,14.118,10.8457a.77208.77208,0,0,0-.40082-.38971L10.89,8.99487h-.20044A4.56014,4.56014,0,0,1,8,9.99628a4.651,4.651,0,0,1-2.72089-1.0014H5.07867L2.27319,10.456a.77208.77208,0,0,0-.40082.38971L.06891,14.83936a1.03948,1.03948,0,0,0,0,.77936.92011.92011,0,0,0,.80145.38959H15.11993a.92021.92021,0,0,0,.80151-.38959A1.03948,1.03948,0,0,0,15.92145,14.83936Z' }),
        React.createElement("path", { d: 'M7.98429,8.511c2.004,0,3.6071-1.9251,3.6071-4.2555C11.59139,1.0132,9.98829,0,7.98429,0s-3.607,1.0132-3.607,4.2555C4.37729,6.5859,5.98039,8.511,7.98429,8.511Z' })));
}
exports.default = SvgUser;
